export default "__VITE_ASSET__9UCnKL2ZXVs7hec3oyt3eA__"